import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/phone_icon.svg'
import _imports_1 from '@/assets/phone_icon_oanda.svg'


const _withScopeId = n => (_pushScopeId("data-v-70a2e2a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid": "step-uploadDocument-desktop",
  class: "container"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "warning"
}
const _hoisted_4 = {
  key: 2,
  class: "warning"
}
const _hoisted_5 = {
  key: 0,
  class: "recommended_header"
}
const _hoisted_6 = { class: "recommended_header_lines" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_8 = { class: "recommended_header_center" }
const _hoisted_9 = {
  key: 0,
  src: _imports_0,
  alt: "phone icon"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_1,
  alt: "phone icon"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "container__subheader t-bold t-center"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 3,
  class: "container__subheader t-bold t-center"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "?", -1))
const _hoisted_16 = {
  key: 4,
  class: "front-side-thank-you"
}
const _hoisted_17 = {
  key: 3,
  class: "recommended-path-header"
}
const _hoisted_18 = {
  key: 0,
  src: _imports_0,
  alt: "phone icon"
}
const _hoisted_19 = {
  key: 1,
  src: _imports_1,
  alt: "phone icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HowToTakePicture = _resolveComponent("HowToTakePicture")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isBadUpload)
      ? (_openBlock(), _createElementBlock("h1", {
          key: 0,
          class: "container__standard-header",
          innerHTML: _ctx.$t(`${_ctx.translationKey}.UploadPhotoIdentityDocument`)
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.store.state.residenceCountry == 'PL')
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.headerWarning`)), 1))
      : _createCommentVNode("", true),
    (_ctx.store.state.residenceCountry == 'ES')
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.spanishHeaderWarning`)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(!_ctx.isMobile && 'recommended_path_container')
    }, [
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                (!_ctx.UtilityHelper.isOandaPath())
                  ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                  : _createCommentVNode("", true),
                (_ctx.UtilityHelper.isOandaPath())
                  ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.alternatePathLabel`)), 1)
              ]),
              _hoisted_11
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isBadUpload)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.IDisClear`)), 1))
        : _createCommentVNode("", true),
      (_ctx.isBadUpload)
        ? (_openBlock(), _createElementBlock("h1", {
            key: 2,
            class: "container__standard-header",
            innerHTML: _ctx.$t(`${_ctx.translationKey}.uploadAgain`)
          }, null, 8, _hoisted_13))
        : _createCommentVNode("", true),
      (_ctx.isBadUpload)
        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.uploadAgainInstructions`)), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "photo-examples",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleShowPopup && _ctx.handleShowPopup(...args)))
      }, [
        _hoisted_15,
        _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.translationKey}.GoodAndBadPhotoExamples`)), 1)
      ]),
      (_ctx.isBack)
        ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.FrontSideThankYou`)), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass({ 'manual-upload': _ctx.isPhotoUpload })
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["gbg-camera-container desktop-container", {
                        'show-help': _ctx.showHelp,
                        'show-camera': _ctx.isShowCamera,
                    }])
        }, [
          (_ctx.showPopup)
            ? (_openBlock(), _createBlock(_component_HowToTakePicture, {
                key: 0,
                "is-popup": true
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            id: "gbgContainer",
            ref: "gbgContainer",
            class: _normalizeClass(["gbgContainer", {
                            'oanda-loader': _ctx.UtilityHelper.isOandaPath(),
                            'show-loader': _ctx.showLoader,
                            'photo-upload': _ctx.isPhotoUpload,
                        }])
          }, null, 2)
        ], 2)
      ], 2)
    ], 2),
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          (!_ctx.UtilityHelper.isOandaPath())
            ? (_openBlock(), _createElementBlock("img", _hoisted_18))
            : _createCommentVNode("", true),
          (_ctx.UtilityHelper.isOandaPath())
            ? (_openBlock(), _createElementBlock("img", _hoisted_19))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.recommendedMobilePathLabel`)), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("button", {
          key: 4,
          type: "button",
          class: "navigation-link up-mobile",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleBackToMobileUpload && _ctx.handleBackToMobileUpload(...args)))
        }, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.uploadFromMobileButton`)) + " » ", 1))
      : _createCommentVNode("", true),
    _createElementVNode("p", {
      class: _normalizeClass(['t-center', { 'is-mobile': _ctx.isMobile }])
    }, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.skipStepReminder`)), 3),
    _createElementVNode("button", {
      type: "button",
      class: "navigation-link link up-later",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleUploadLater && _ctx.handleUploadLater(...args)))
    }, _toDisplayString(_ctx.$t(`${_ctx.translationKey}.uploadLaterButton`)) + " » ", 1)
  ]))
}